<template>
  <div>
    <!-- <div class="topImg">
      <router-link to="/">
        <img :src="logoUrl" height="90px" />
      </router-link>
    </div> -->
    <div class="topbar">
      <!--路由导航-->
      <ul class="top">
        <router-link to="/">
          <img :src="logoUrl" height="90px" />
        </router-link>
        <div>
          <li class="item" :class="tabIndex == 0 ? 'itemActive' : ''" @click="tabIndex = 0">
            <router-link to="/">首页</router-link>
          </li>

          <li class="item item1" :class="tabIndex == index + 1 ? 'itemActive' : ''" v-for="(item, index) in tabList"
            :key="index">
            <router-link to="/" @click.native="goPageDetails(item, item.id, index)">{{
            item.labelName
          }}</router-link>
            <ul v-if="item.children_first && item.children_first.length > 0" class="liBack">
              <div class="childrenTop"></div>
              <div class="sanJiaoBlack"></div>
              <div class="sanJiao"></div>

              <li v-for="(child, i) in item.children_first" :key="i" class="childrenItem">
                <router-link to="/" @click.native="goPageDetails(child, item.id, index)">{{ child.labelName
                  }}</router-link>
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabList: [],
      logoUrl: '',
      companyInfo: {},
      tabIndex: 0
    };
  },
  mounted() {
    console.log(new Date())
    this.searchMenuList();
    let companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
    this.companyInfo = companyInfo;
    if (companyInfo.logoURL) {
      this.logoUrl = companyInfo.documentsIISHttp + companyInfo.logoURL + '?' + new Date().getTime();
    }
  },

  methods: {
    searchMenuList() {
      this.Api.NavigationTitleSearchApi({
        userId: "",
        userName: "",
      }).then((res) => {
        if (res.Code == 200) {
          this.tabList = res.Data.firstLevels;
          this.$nextTick(() => {
            // this.changeStyle();
          });
        }
      });
    },

    changeStyle() {
      // 修改背景颜色
      // document.querySelector(".top").style.background = window.tabBackColor;

      // 修改文字颜色
      document.getElementsByTagName("a").forEach((el) => {
        // el.style.color = window.fontColor;
      });

      // 修改鼠标移动上背景颜色
      // const itemEle1 = document.querySelectorAll(".liBack");

      // itemEle1.forEach((el) => {
      //   // el.style.backgroundColor = window.tabHoverBackColor;
      //   el.style.backgroundColor = '#ddd';
      // });

      // const itemEle = document.querySelectorAll(".item");
      // itemEle.forEach((el) => {
      //   el.addEventListener("mouseover", function () {
      //     this.style.backgroundColor = window.tabHoverBackColor;
      //   });
      //   el.addEventListener("mouseleave", function () {
      //     this.style.backgroundColor = window.tabBackColor;
      //   });
      // });

      // const hobverEle = document.querySelectorAll(".item1");
      // hobverEle.forEach((el) => {
      //   el.addEventListener("mouseover", function () {
      //     this.style.backgroundColor = window.tabHoverBackColor;
      //     el.style.color = '#fff';
      //   });
      //   el.addEventListener("mouseleave", function () {
      //     // this.style.backgroundColor = window.tabBackColor;
      //     this.style.backgroundColor = '#fff';
      //   });
      // });
    },

    routerFun(val) {
      this.$router.push({
        name: "companyIntro",
        params: { activeId: val },
      });
    },
    routerNesFun(val) {
      if (val == 0) {
        this.$router.push({
          name: "all",
          params: { activeId: val },
        });
      }
      // else if (val == 1) {
      //   this.$router.push({
      //     name: "forum",
      //     params: { activeId: val },
      //   });
      // } else {
      //   this.$router.push({
      //     name: "forumOutside",
      //     params: { activeId: val },
      //   });
      // }
    },
    // 业务领域
    routerTransFun(val) {
      this.$router.push({
        name: "productClassify",
        params: { activeId: val },
      });
    },
    // 社会责任
    routerDutyFun(val) {
      if (val == 1) {
        this.$router.push({
          name: "Risk",
          params: { activeId: val },
        });
      } else {
        this.$router.push({
          name: "ZhiDu",
          params: { activeId: val },
        });
      }
    },

    goPageDetails(val, id, index) {
      console.log(JSON.stringify(this.tabIndex))
      this.tabIndex = index + 1
      console.log(val, index)
      if (val.type == "新闻类") {
        if (val.level == "二级") {
          val.newsType = val.labelName;
          val.id = id;
        } else {
          val.newsType = "1";
        }
        this.$router.push({
          name: "all",
          params: { navigationId: val.id, type: val.newsType },
        });
      } else if (val.type == "商品类") {
        this.$router.push({
          name: "Investigate",
          params: { navigationId: val.id },
        });
        // this.$router.push('/Investigate')
      } else {
        this.$router.push({ name: "pageDetails", params: { id: val.id } });
      }
    },
  },
  computed: {},
  created() { },
};
</script>

<style lang="less" scoped>
.top ul {
  display: none;
  position: absolute;
  // padding-top: 0.5em;
  // background-color: #00345e;
  width: 100px;
  color: #000;
}

.top ul li {
  float: none;
  // border: 0 none transparent;
  border-bottom: 1px solid #e7edf5;
  // background-color: #0f365c;
  // color: #fff;
  font-size: 70%;
}

.top li:hover ul {
  display: block;
}

.topImg {
  width: 80%;
  margin: 10px auto;
}

// /deep/ .router-link-active {
//   display: block;
//   width: 160px;
//   background: #00345e !important;
// }

.topbar {
  width: 100%;
  display: flex;
  align-items: flex-end;
  // position: relative;
  // background: #0068b7;
  margin: 0 auto;
}

// .img {
//   width: 90px;
//   display: inline;
//   background: none !important;
//   position: relative;
// }

.img>img {
  position: absolute;
  left: 0;
  top: 10;
}

a {
  display: inline-block;
  color: #000;
  width: 100%;
}

a:hover {
  color: #fff;
}

.item {
  width: 100px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  border-radius: 20px;
  margin-left: 10px;
}

.item:hover {
  background-color: #007aff;
}

.item:hover a {
  color: #fff;
}

.itemActive {
  background-color: #007aff;
  color: #fff !important;
}

.itemActive a {
  color: #fff !important;
}

.liBack {
  margin-top: 8px;
  box-shadow: #adadad 0px 0px 3px;
  background-color: #fff;
  position: relative;
  z-index: 1000;
}

.liBack a {
  color: #000 !important;
}

.childrenItem:hover a {
  color: #007aff !important;
}
.childrenTop {
  width: 100%;
  height: 8px;
  position: absolute;
  top: -8px;
}
.sanJiao {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  position: absolute;
  top: -8px;
  left: calc(50% - 8px);
}
.sanJiaoBlack {
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #adadad;
  position: absolute;
  top: -9px;
  left: calc(50% - 9px);
}
.top {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  // background: #0068b7;
  z-index: 1000;
}

.top>div {
  display: flex;
}
</style>
